import { render, staticRenderFns } from "./PwaInstall.vue?vue&type=template&id=268b1d29&scoped=true&"
import script from "./PwaInstall.vue?vue&type=script&lang=js&"
export * from "./PwaInstall.vue?vue&type=script&lang=js&"
import style0 from "./PwaInstall.vue?vue&type=style&index=0&id=268b1d29&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268b1d29",
  null
  
)

export default component.exports